// useGlobalHotkeys.ts
import { useHotkeys, HotkeyItemOptions } from '@mantine/hooks';
import { useLogout } from 'hooks/useLogout';
import {
  hotkeysConfig,
  HotkeyConfigItem,
  NavigateFunction,
} from 'constants/hotkeyConfig';

export const useGlobalHotkeys = (navigateFunction?: NavigateFunction): void => {
  const navigate: NavigateFunction =
    navigateFunction ||
    ((path: string) => {
      window.location.href = path;
    });

  const logout = useLogout();

  const hotkeysArray: [
    string,
    (event: KeyboardEvent) => void,
    HotkeyItemOptions?
  ][] = hotkeysConfig.map((item: HotkeyConfigItem) => [
    item.keys,
    (event: KeyboardEvent) => item.action(navigate, logout, event),
    item.options,
  ]);

  useHotkeys(hotkeysArray);
};
